/**
 * Estilo de animação fade-in para componentes Stack do Fluent UI.
 * Aplica uma transição suave de opacidade de 0 para 1 em 0.8 segundos.
 *
 * @example
 *
 * // Aplicar diretamente em um Stack
 * <Stack styles={fadeIn}>
 *   <YourComponent />
 * </Stack>
 *
 * @example
 * // Combinar com outros estilos
 * <Stack styles={{
 *   ...fadeIn,
 *   root: {
 *     ...fadeIn.root,
 *     padding: 20,
 *     backgroundColor: "#fff"
 *   }
 * }}>
 *   <YourComponent />
 * </Stack>
 *
 * @remarks
 * - Compatível com a prop `styles` de componentes Fluent UI
 * - A animação executa apenas uma vez ao montar o componente
 */
export const fadeIn = {
  root: {
    animation: "fadeIn 0.8s ease-in",
    "@keyframes fadeIn": {
      "0%": { opacity: 0 },
      "100%": { opacity: 1 }
    }
  }
};
